import type { ReactElement } from 'react';
import { renderMusic } from '@reels/shared/music';
import { t } from '../i18n';

export function MusicRights({ music }: { music: unknown }): ReactElement {
  const info = renderMusic(music);
  if (!info) return <p className="muted small">{t('components.musicRights.legacy')}</p>;
  if (info.status === 'disabled') return <p className="muted small">{t('components.musicRights.disabled')}</p>;
  if (info.status === 'unavailable') return <p className="muted small">{t('components.musicRights.unavailable')}</p>;
  const { credit } = info;
  return (
    <section className="card field music-rights" aria-label={t('components.musicRights.aria')}>
      <h3>{t('components.musicRights.title')}</h3>
      <p>{credit.title} · {credit.artist}</p>
      <p className="small">{credit.attributionRequired
        ? t('components.musicRights.attribution')
        : t('components.musicRights.free')}</p>
      <p className="small"><a href={credit.sourceUrl} target="_blank" rel="noreferrer">{t('components.musicRights.source')}</a> · <a href={credit.licenseUrl} target="_blank" rel="noreferrer">{credit.license}</a></p>
      {credit.attributionRequired && <textarea aria-label={t('components.musicRights.creditAria')} readOnly rows={6} value={credit.attribution} onFocus={(event) => event.target.select()} />}
      <p className="muted small">{credit.contentIdNote}</p>
    </section>
  );
}
